export const getCustomClusterMinMaxDuration = clusters => {
  let allDurations = [];

  clusters.forEach(clusterObj => {
    clusterObj.combinations.forEach(combination => {
      allDurations.push(combination.option.flight_time);

      combination.next_leg_options?.forEach(nextOption => {
        allDurations.push(nextOption.option.flight_time);
      });
    });
  });

  if (allDurations.length === 0) {
    return [0, 0];
  }

  return [Math.min(...allDurations), Math.max(...allDurations)];
};

export const getClusterMinMaxDuration = cluster => {
  const allDurations = cluster.flatMap(clusterObj =>
    clusterObj.legs.flatMap(leg =>
      leg.options.map(option => option.flight_time)
    )
  );

  if (allDurations.length === 0) {
    return [undefined, undefined];
  }

  const minDuration = Math.min(...allDurations);
  const maxDuration = Math.max(...allDurations);

  return [minDuration, maxDuration];
};
